import { isQualifEnvironment } from '../config/environment';

/**
 * Fonctionnalités expérimentales — qualif uniquement (host QA + flag build explicite).
 * Jamais activé sur inventwee.airzk.fr / app.inventwee.com même si le flag est présent dans l'image.
 */
export function isBulkPhotoLieuEnabled(): boolean {
  if (!isQualifEnvironment()) {
    return false;
  }
  return import.meta.env.VITE_FEATURE_BULK_PHOTO_LIEU === 'true';
}

export function isOpenRouterVisionEnabled(): boolean {
  if (!isQualifEnvironment()) {
    return false;
  }
  return import.meta.env.VITE_FEATURE_OPENROUTER_VISION === 'true';
}
